import { render } from "./coolLogo.vue?vue&type=template&id=bf00095e"
import script from "./coolLogo.vue?vue&type=script&lang=js"
export * from "./coolLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__